var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import APIIN from "@/utils/APIIN";
import { call, put, takeLatest } from "redux-saga/effects";
import { GET_DECLARATION_STATUS_REQUEST, getDeclarationStatusFailure, getDeclarationStatusSuccess } from "../../actions";
const onGetDeclarationStatus = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.get(`company/admin/gst/exists?type=${action.payload.type}&companyId=${action.payload.companyId}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* getDeclarationStatusWorker(action) {
    try {
        const data = yield call(onGetDeclarationStatus, action);
        yield put(getDeclarationStatusSuccess(data));
    }
    catch (error) {
        yield put(getDeclarationStatusFailure(error));
    }
}
export function* watchGetDeclarationStatus() {
    yield takeLatest(GET_DECLARATION_STATUS_REQUEST, getDeclarationStatusWorker);
}
